import React from 'react';
import DropdownField, { DropdownOption } from '../formFields/DropdownField'
import { mirrorData } from '../utils/appUtils';
import { WrappedFieldProps } from "redux-form";

export interface ReduxDropdownProps {
  readonly label?: string;
  readonly required?: boolean;
  readonly options: readonly DropdownOption[];
  readonly onChange?: (value: string, name: string) => void;
  readonly errMsgs?: string;
  readonly onBlur?: (value: string, name: string, event: React.FocusEvent<HTMLSelectElement, Element>) => void;
  readonly disabled?: boolean;
}

/**
 * to be wrapped with redux-form Field component
 * @deprecated redux-form needs to be phased out
 */
export default function ReduxFormDropdownField(props: ReduxDropdownProps & WrappedFieldProps) {
  const { input, meta, label, required, options, onChange, errMsgs, onBlur, disabled } = props

  const onChangeValue = (event: React.ChangeEvent<HTMLSelectElement>, _previous?: string | number | readonly string[]) => {
    input.onChange(event);
    onChange && onChange(event.target.value, input.name);
  }

  const customOnBlur = (e: React.FocusEvent<HTMLSelectElement, Element>) => {
    mirrorData(input.name, input.value)
    onBlur && onBlur(input.value, input.name, e)
  }

  // do not display warning if the field has not been touched or if it's currently being edited
  const error = meta.touched && !meta.active && !meta.valid ? (meta.error as string) : (errMsgs ?? "");

  return <DropdownField
    label={label}
    required={required}
    errMsg={error}
    onChange={onChangeValue}
    onBlur={customOnBlur}
    options={options}
    input={input}
    meta={meta}
    disabled={disabled}
  />
}
